<!-- Ícono que muestra/oculta los filtros -->
<div
  class="cursor-pointer text-primary-base flex items-center justify-start gap-2 mb-4"
  (click)="toggleFilters()">
  <span
    [ngClass]="{
      'bg-primary-light': showFilters,
      'border-primary-base border text-sm text-primary-base px-2 py-1 rounded': true,
    }"
    class="border-primary-base border font-semibold text-sm text-primary-base px-2 py-1 rounded">
    <i
      [class.pi]="true"
      [class.pi-filter]="!showFilters"
      [class.pi-filter-slash]="showFilters"
      style="font-size: 0.8rem"></i>
    {{ showFilters ? 'Ocultar filtros' : 'Desplegar filtros' }}
  </span>
</div>

<!-- Contenido que se muestra u oculta -->
<div
  *ngIf="showFilters"
  class="bg-neutral-light py-6 px-8 min-w-full flex flex-col text-primary-base justify-between gap-8">
  <div [class]="containerClass">
    <div *ngFor="let filter of filtersAdvanced; let i = index">
      <div class="flex gap-2">
        @if (filter.type === 'dropdown') {
          <app-dropdown
            [options]="filter.options"
            [label]="filter.label"
            (select)="onDropdownChange(i, $event)" />
        } @else if (filter.type === 'inputNumber') {
          <div class="filter-item flex flex-col">
            <label class="text-primary-base">{{ filter.label }}</label>
            <input
              type="number"
              [(ngModel)]="filter.selected"
              placeholder="Buscar por {{ filter.label }}"
              class="border border-primary-base rounded text-primary-base focus:outline-none focus:border-primary-base" />
          </div>
        } @else if (filter.type === 'multiselect') {
          <div class="filter-item flex flex-row gap-2">
            <div class="flex flex-col gap-2">
              <app-multiselect
                #filterRef
                [options]="filter.options"
                [label]="filter.label"
                [html]="filter.label"
                [isMultiselectable]="true"
                (select)="onMultiselectChange($event, i)"
                [disabled]="filter.disabled" />
            </div>
          </div>
        } @else if (filter.type === 'dateRange') {
          <div class="filter-item flex flex-row gap-2">
            <div class="flex flex-col gap-2">
              <app-date-picker
                #filterRef
                [inline]="false"
                [label]="filter.label"
                [type]="'range'"
                size="sm"
                (selectedDateRange)="onRangeSelected($event, i)" />
            </div>
          </div>
        } @else if (filter.type === 'inputText') {
          <div class="filter-item flex flex-col gap-2">
            <label class="text-primary-base">{{ filter.label }}</label>
            <input
              type="text"
              [(ngModel)]="filter.selected"
              placeholder="Buscar por {{ filter.label }}"
              class="border border-primary-base rounded text-primary-base focus:outline-none focus:border-primary-base" />
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Botones -->
  <div class="flex justify-start">
    <div class="flex flex-row items-start gap-4">
      <app-buttons
        [classes]="'bg-primary-base text-[16px] text-white px-3 py-1.5 rounded'"
        (click)="onApplyFilters()"
        [isWhite]="false"
        [label]="'Aplicar filtros'" />
      <span
        class="cursor-pointer text-primary-base font-semibold text-[16px] underline min-w-32 ml-1 mt-2"
        (click)="onClearFilters()">
        Limpiar filtros
      </span>
    </div>
  </div>
</div>
